import React, { useEffect, useState, useCallback } from "react";
import StatusCards from "./statusCards";
import Vendors from "./vendors";
import { CircularProgress, Box } from "@mui/material";
import { useNotification } from "../../context/NotificationContext";

export default function Dashboard({ userData }) {
  const { showNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState({});
  const isAdmin = userData?.isAdmin === true; // true or false

  const fetchDashboardData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const res = await fetch(
        `${process.env.REACT_APP_BACKENDORDERURL}/dashboard`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) {
        if (res.status === 404) {
          showNotification(
            " Dashboard endpoint not found. Check if your backend is running and the endpoint exists.",
            "error"
          );
          throw new Error("Dashboard API not found");
        }

        showNotification(` Server error: ${res.status}`, "error");
        throw new Error(`Server Error ${res.status}`);
      }

      const resdata = await res.json();

      if (resdata?.success && resdata.data) {
        setDashboardData(resdata.data);
      } else {
        throw new Error("Invalid dashboard data format");
      }
    } catch (err) {
      console.error("Dashboard Load Error:", err);
      showNotification(" Error loading dashboard data", "error");
      setError(err.message);
      setDashboardData({});
    } finally {
      setIsLoading(false);
    }
  }, [showNotification]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return (
    <section id="dashboard-section" className="content-body">
      <h2>Dashboard</h2>

      {isLoading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="200px"
        >
          <CircularProgress />
        </Box>
      )}

      {error && <p style={{ color: "red" }}>Error: {error}</p>}

      {!isLoading && !error && dashboardData && (
        <>
          <StatusCards
            dashboardData={dashboardData}
            setDashboardData={setDashboardData}
            userData = {userData}
          />
          {isAdmin && (
            <>
              <h2>Vendors</h2>
              <Vendors
                dashboardData={dashboardData}
                setDashboardData={setDashboardData}
              />
            </>
          )}
        </>
      )}
    </section>
  );
}
